import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getProvinceList(currentPage, pageSize) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/provinces`,
    method: 'get',
    params: {
      currentPage, pageSize,
    },
  });
}

export function findProvince(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/provinces/${ id }`,
    method: 'get',
  });
}

export function saveProvince(province) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/provinces`,
    method: 'post',
    data: province,
  });
}

export function updateProvince(province) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/provinces`,
    method: 'patch',
    data: province,
  });
}

export function delProvince(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/provinces/${ id }`,
    method: 'delete',
  });
}
